<template>
  <v-autocomplete
    :item-text="itemText"
    :item-value="itemValue"
    :value="value"
    @input="onInput"
    @change="onChange"
    :items="items"
    clearable
    :label="label"
  />
</template>

<script>
import axios from '@/libs/axios';
export default {
  props: {
    value: {},
    label: {
      type: String,
      default: 'Pilih option',
    },
    itemText: {
      type: [String, Function],
      default: 'nama',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const res = await axios.get(`/v1/kode-perkiraan/without-child`);
        this.items = res.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    onInput(val) {
      this.$emit('input', val);
    },
    onChange(val) {
      this.$emit('change', val);
    },
  },
  computed: {
    modelValueProxy: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
